/**
 * The middleware serves the React profiling build (`profiling.html`, built with `--mode profiling`)
 * instead of the regular `index.html` while this cookie is set. Toggled by the "React render timing"
 * switch in the Canvas Debugger; a full page reload is required for a build switch to take effect.
 */
export const PROFILING_BUILD_COOKIE = "qerent-profiling-build";

/**
 * True when running the React profiling bundle. `__PROFILING_BUILD__` is a Vite define that only
 * exists in the web app's own builds — the `typeof` guard keeps modules shared via `@qerent/lib`
 * (built separately, without the define) from throwing a ReferenceError.
 */
export const isProfilingBuild = typeof __PROFILING_BUILD__ !== "undefined" && __PROFILING_BUILD__;

/** Sets/clears the build-selection cookie; the served build changes on the next full page load. */
export function setProfilingBuildCookie(enabled: boolean) {
    document.cookie = enabled
        ? `${PROFILING_BUILD_COOKIE}=1; path=/; max-age=31536000; SameSite=Strict; Secure`
        : `${PROFILING_BUILD_COOKIE}=; path=/; max-age=0; SameSite=Strict; Secure`;
}
